import GetMembershipDetailRequestModelBase from '../_generated/modelBases/get-membership-detail-request-model-base';

export default class GetMembershipDetailRequestModel extends GetMembershipDetailRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
